import { TableRow } from '@crossnokaye/ux-common';

import { CompressorEnergyAIStageCell } from './compressor-energy-ai-stage-cell';
import type { EnergyAIStageRow } from '../compressor-energy-ai.types';

interface CompressorEnergyAIStageRowProps {
  isEnergyAIActive: boolean;
  isLockedByOther: boolean;
  isUnavailableInSequence: boolean;
  row: EnergyAIStageRow;
}

// Deliberately not memoized: `rows` is rebuilt from scratch on every reading
// tick, so every `row` is a fresh object and a memo boundary here can never
// hit - it only adds a comparison to the work it was meant to save.
export const CompressorEnergyAIStageRow = ({
  isEnergyAIActive,
  isLockedByOther,
  isUnavailableInSequence,
  row,
}: CompressorEnergyAIStageRowProps) => {
  return (
    <TableRow data-component="CompressorEnergyAIStageRow">
      <CompressorEnergyAIStageCell
        isEnergyAIActive={isEnergyAIActive}
        isLockedByOther={isLockedByOther}
        isUnavailableInSequence={isUnavailableInSequence}
        row={row}
      />
    </TableRow>
  );
};
